import { AbstractMap } from './Map.js';
import { MapOptions } from '../model/MapOptions.js';
import { Utils } from '../utils/Utils.js';
import { I18n } from '../utils/i18n.js';

export class MapFactory {
  public static getMap(options: MapOptions): Promise<AbstractMap> {
    return new Promise(async (resolve) => {
      // Initialize i18n with the specified language or browser language
      I18n.getInstance(options.language);

      let map: AbstractMap;
      const timeout = setTimeout(() => {
        console.warn('Missed loaded event');
        resolve(map);
      }, 1000);

      if (options.mapboxKey) {
        //throw new Error('Mapbox maps are no longer supported. Please use Maplibre with appropriate style and tiles.');
        // Load Mapbox CSS and clean up MapLibre CSS
        await Utils.loadMapCss('mapbox');
        const mapboxMap = await import('../mapbox/MapboxMap.js');
        map = new mapboxMap.MapboxMap(options);
      } else {
        // Load MapLibre CSS and clean up Mapbox CSS
        await Utils.loadMapCss('maplibre');
        const maplibreMap = await import('../maplibre/MaplibreMap.js');
        map = new maplibreMap.MaplibreMap(options);
      }

      map.addEventListener('loaded', () => {
        clearTimeout(timeout);
        resolve(map);
      });
    });
  }
}
